import { appConfig } from "@/constants";
import { authorizedPost } from "../request";
import type { LinkedAccountPlatform } from "./linkedAccounts";

const LOGIN_PAGE_NAME = "/steam-login";
const CLIENT_PAGE_NAME = "/steam-openid";

export const SteamLinkedAccountPlatform: LinkedAccountPlatform = {
  imageUrl: "/images/quests/steam-logo.svg",
  name: "Steam",
  questAction: "add to wishlist",
  getAuthorizeUrl: (loginOnly?: boolean) => {
    const returnTo = loginOnly ? CLIENT_PAGE_NAME : LOGIN_PAGE_NAME;
    const redirectUri = `${appConfig.BASE_REDIRECT_URL}${returnTo}`;
    const steamOauthUrl = new URL("https://steamcommunity.com/openid/login");

    const params = {
      "openid.ns": "http://specs.openid.net/auth/2.0",
      "openid.mode": "checkid_setup",
      "openid.return_to": redirectUri,
      "openid.realm": appConfig.BASE_REDIRECT_URL,
      "openid.identity": "http://specs.openid.net/auth/2.0/identifier_select",
      "openid.claimed_id": "http://specs.openid.net/auth/2.0/identifier_select",
    };

    for (const [key, value] of Object.entries(params)) {
      steamOauthUrl.searchParams.append(key, value);
    }

    return steamOauthUrl.toString();
  },
  login: async (accessToken: string, callbackParams: string) => {
    const response = await authorizedPost(
      "/passport-profile/v1/steam-auth",
      { url_params: callbackParams },
      accessToken,
    );

    const { external_user_id } = response;
    if (!external_user_id) {
      throw new Error("Invalid response format from Steam authentication.");
    }

    localStorage.setItem("steam_user_id", external_user_id);

    return response;
  },
  validateQuest: async (
    gameId: string,
    questId: string,
    accessToken: string,
  ) => {
    return await authorizedPost(
      "/passport-profile/v1/steam-quest",
      { quest_id: questId, game_id: gameId },
      accessToken,
    );
  },
  isLoggedIn: () => {
    return !!localStorage.getItem("steam_user_id");
  },
};
